// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__PSYVL","footer":"ModalFilter_footer__3627Z"};